const vsplSliders = {
  aboutHeroSlider() {
    const $progressBar = jQuery(".heroSliderProgressBar");
    const $progressBarLabel = jQuery(".slider__label");

    jQuery("#heroSlider").on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        let calc = (nextSlide / (slick.slideCount - 1)) * 100;
        $progressBar.css("width", calc + "%").attr("aria-valuenow", calc);
        $progressBarLabel.text(calc + "% completed");
      }
    );

    jQuery("#heroSlider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 5000,
      autoplayspeed: 5000,
      autoplay: true,
      infinite: true,
      fade: false,
      cssEase: "linear",
    });
  },
  storyCategories() {
    const $progressBar = jQuery("#storycatrgories_bar");

    jQuery("#storycatrgories").on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        let calc = (nextSlide / (slick.slideCount - 1)) * 100;
        $progressBar.css("width", calc + "%").attr("aria-valuenow", calc);
      }
    );

    jQuery("#storycatrgories").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      speed: 5000,
      autoplayspeed: 5000,
      autoplay: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
  bmTestimonialSlider() {
    jQuery("#vspl__bm--testimonials").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      speed: 5000,
      autoplayspeed: 5000,
      dots: false,
      autoplay: true,
      centerMode: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
 /* sliderStylePrimary($sliderID, $normal = 3, $mobile = 2) {
    jQuery($sliderID).slick({
      slidesToShow: $normal,
      slidesToScroll: 2,
      speed: 5000,
      autoplayspeed: 5000,
      autoplay: true,
      centerMode: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 676,
          settings: {
            slidesToShow: $mobile,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
  sliderStyleSecondary($sliderID, $normal = 3, $tab = 2, $mobile = 1) {
    jQuery($sliderID).slick({
      slidesToShow: $normal,
      slidesToScroll: 1,
      speed: 5000,
      autoplayspeed: 5000,
      autoplay: true,
      centerMode: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 676,
          settings: {
            slidesToShow: $tab,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: $mobile,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },*/
  sliderStyleBM($sliderID, $normal = 1, $tab = 1, $mobile = 1) {
    jQuery($sliderID).slick({
      slidesToShow: $normal,
      slidesToScroll: 1,
      speed: 5000,
      autoplayspeed: 5000,
      autoplay: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 676,
          settings: {
            slidesToShow: $tab,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: $mobile,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
  sliderPeopleSecondary($sliderID, $normal = 4, $tab = 2, $mobile = 2) { // using in bettermarket
    jQuery($sliderID).slick({
      slidesToShow: $normal,
      slidesToScroll: 1,
      speed: 5000,
      autoplayspeed: 5000,
      autoplay: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 676,
          settings: {
            slidesToShow: $tab,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: $mobile,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
  sliderBrandPartners($sliderID, $normal = 2, $tab = 2, $mobile = 1) { //used in advertisement brand campaigns section
    jQuery($sliderID).slick({
      slidesToShow: $normal,
      slidesToScroll: 1,
      speed: 5000,
      autoplayspeed: 5000,
      autoplay: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 676,
          settings: {
            slidesToShow: $tab,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: $mobile,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
  sliderMobileOnly($sliderID) { // using in bettermentor
    jQuery($sliderID).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 5000,
      autoplayspeed: 5000,
      autoplay: true,
      centerMode: false,
      mobileFirst: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 676,
          settings: "unslick",
        },
      ],
    });
  },
  init() {

    if (jQuery("#heroSlider").length > 0) {
      this.aboutHeroSlider();
    }

    if (jQuery('#vspl_tba_mentor [data-id="vspl__bettermentor"]').length > 0) {
      this.sliderMobileOnly('#vspl_tba_mentor [data-id="vspl__bettermentor"]');
    }
    if (jQuery('#vspl_tba_course [data-id="vspl__bettermentor"]').length > 0) {
      this.sliderMobileOnly('#vspl_tba_course [data-id="vspl__bettermentor"]');
    }

    if (jQuery("#vspl__bettermarketbanner").length > 0) {
      this.sliderStyleBM("#vspl__bettermarketbanner");
    }

    if (jQuery("#vspl__featured-product").length > 0) {
      this.sliderPeopleSecondary("#vspl__featured-product");
    }
    if (jQuery("#vspl__brands").length > 0) {
      this.sliderPeopleSecondary("#vspl__brands", 5, 5, 3);
    }
    if (jQuery("#vspl__bm--articles").length > 0) {
      this.sliderPeopleSecondary("#vspl__bm--articles");
    }

    if (jQuery("#vspl__bm--testimonials").length > 0) {
      this.bmTestimonialSlider();
    }

    if (jQuery("#storycatrgories").length > 0) {
      this.storyCategories();
    }
  },
};

//better market scripts//

$(document).on('ready', function () {
  $("#mobileBtnFix").hide();
  $(window).on('scroll', function () {

    var navHeight = $(window).height() + 150;
    if ($(window).scrollTop() > navHeight) {
      $("#mobileBtnFix").show();
      $('.vspl__section--btn').addClass('fixed-btn');
    }
    else {
      $('.vspl__section--btn').removeClass('fixed-btn');
      $("#mobileBtnFix").hide();
    }
  });
  $(".vspl__page--product-price-display").addClass("strike-through");
})
setTimeout(function () {
  $(".vspl__page--product-deal-display").addClass("strike-through");
  $(".vspl__page--product-price-display").removeClass("strike-through");
  $(".vspl__page--product-saved").hide();
  $(".vspl__page--product-price-tax").text(" ( Inclusive of all taxes )");
}, 600000); //(10 mins * 60 seconds per minute * 1000 milliseconds per second. 1min=60000)
